module.exports = __webpack_public_path__ + "img/echo.eebd3167.png";